{
  "auth-process-pages": {
    "login-process-steps": {
      "step-1": {
        "title": "Benutzername",
        "description": "Ihre E-Mail-Adresse oder Telefonnummer"
      },
      "step-2": {
        "title": "Sicherheit",
        "description": "Bitte geben Sie die erforderlichen Informationen ein"
      }
    },
    "register-process-steps": {
      "step-1": {
        "title": "Persönliche Informationen",
        "description": "Bitte das Informationsformular ausfüllen"
      },
      "step-2": {
        "title": "Anmeldedaten",
        "description": "Anmeldedaten eingeben"
      },
      "step-3": {
        "title": "Konto verifizieren",
        "description": "Sie erhalten eine Bestätigungsnummer per Email"
      },
      "step-4": {
        "title": "Konto erstellt",
        "description": "Ihr Konto wurde erstellt!"
      }
    },
    "meta": {
      "login": {
        "title": "Anmeldung",
        "description": "Anmeldung bei Beauty Booking"
      },
      "register": {
        "title": "Registrierung",
        "description": "Registrieren Sie Ihr neues Konto"
      }
    }
  }
}
